import React, { FC } from 'react';
import { graphql, createFragmentContainer, Environment } from 'react-relay';

// types
import { PdpRespDealerChatLazy_viewer as Viewer } from './__generated__/PdpRespDealerChatLazy_viewer.graphql';

const LazyComponent = React.lazy(
    () => import(/* webpackChunkName: "PdpRespDealerChat" */ './PdpRespDealerChat')
);
type Props = {
    viewer: Viewer;
    environment: Environment;
    isInitiallyMinimized: boolean;
};

export const PdpRespDealerChatLazyComponent: FC<Props> = props => (
    <React.Suspense fallback="">
        <LazyComponent {...props} />
    </React.Suspense>
);

export const PdpRespDealerChatLazy = createFragmentContainer(PdpRespDealerChatLazyComponent, {
    viewer: graphql`
        fragment PdpRespDealerChatLazy_viewer on Viewer {
            ...PdpRespDealerChat_viewer
        }
    `,
});
